import * as React from "react";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";

export default function ComboBox({
  title,
  autocmpleteValue,
  setAutocompleteValue,
  options,
  setpagination,
}) {
  return (
    <Autocomplete
      options={options}
      getOptionLabel={(option) => option.label}
      value={autocmpleteValue}
      onChange={(event, newValue) => {
        setpagination && setpagination(newValue);
        setAutocompleteValue(newValue);
      }}
      renderInput={(params) => (
        <TextField {...params} label={title} variant="outlined" />
      )}
      renderOption={(props, option) => (
        <li {...props} key={option.value}>
          {option.label}
        </li>
      )}
      renderTags={(value, getTagProps) =>
        value.map((option, index) => (
          <span {...getTagProps({ index })} key={option.value}>
            {option.value.substring(0, Math.floor(option.value.length / 2))}
          </span>
        ))
      }
    />
  );
}
